import { AgencyFit } from "./AgencyFit";
import { AISection } from "./AISection";
import { CapabilityShift } from "./CapabilityShift";
import { Collaboration } from "./Collaboration";
import { Credibility } from "./Credibility";
import { FeatureCarousel } from "./FeatureCarousel";
import { Footer } from "./Footer";
import { Hero } from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { Nav } from "./Nav";
import { Outcomes } from "./Outcomes";
import { ProductPeek } from "./ProductPeek";
import { Shift } from "./Shift";
import { graphite } from "./theme";
import { WhatRarionDoes } from "./WhatRarionDoes";

export type ExperimentalLandingPageProps = {
  currentUser: { name: string; appUrl: string } | null;
  signInUrl: string;
  copyrightYear: number;
};

export function ExperimentalLandingPage(props: ExperimentalLandingPageProps) {
  const theme = graphite;
  return (
    <div
      style={{
        position: "relative",
        background: theme.bg,
        color: theme.fg,
        fontFamily: theme.font,
      }}
    >
      <Nav theme={theme} signInUrl={props.signInUrl} currentUser={props.currentUser} />
      <Hero theme={theme} />
      <Shift theme={theme} />
      <Collaboration theme={theme} />
      <FeatureCarousel theme={theme} />
      <WhatRarionDoes theme={theme} />
      <ProductPeek theme={theme} />
      <AISection theme={theme} />
      <HowItWorks theme={theme} />
      <CapabilityShift theme={theme} />
      <AgencyFit theme={theme} />
      <Outcomes theme={theme} />
      <Credibility theme={theme} />
      <Footer theme={theme} copyrightYear={props.copyrightYear} />
    </div>
  );
}
